import React from 'react'
import { Text } from '@workwhile/ui'
import { PayoutPaymentMethod } from 'api/payments/getUserPayments'
import { toTitleCase } from 'lib/string'

const getPayoutDestinationLabel = (
  paymentMethod: Pick<PayoutPaymentMethod, 'destinationType'>
): string =>
  paymentMethod.destinationType === 'debit_card'
    ? 'Instant pay destination'
    : 'Payroll destination'

const getPayoutDestinationKindLabel = (
  paymentMethod: Pick<PayoutPaymentMethod, 'destinationType' | 'accountType'>
): string => {
  if (paymentMethod.destinationType === 'debit_card') {
    return 'Debit card'
  }

  if (paymentMethod.accountType) {
    return `${toTitleCase(paymentMethod.accountType)} account`
  }

  return 'Bank account'
}

const formatPayoutPaymentMethod = (
  paymentMethod: PayoutPaymentMethod
): string => {
  const parts: string[] = []

  if (paymentMethod.displayName) {
    parts.push(paymentMethod.displayName)
  } else {
    parts.push(getPayoutDestinationKindLabel(paymentMethod))
  }

  if (paymentMethod.last4) {
    parts.push(`•••• ${paymentMethod.last4}`)
  }

  return parts.join(' · ')
}

/** One-line destination summary for payout tooltips. */
export const PayoutPaymentMethodSummary = ({
  paymentMethod,
}: {
  paymentMethod: PayoutPaymentMethod
}) => (
  <Text fontSize={2}>
    {getPayoutDestinationLabel(paymentMethod)}:{' '}
    {formatPayoutPaymentMethod(paymentMethod)}
  </Text>
)
